import { render, staticRenderFns } from "./DigitalMainView.vue?vue&type=template&id=b5e39e18&scoped=true&"
import script from "./DigitalMainView.vue?vue&type=script&lang=js&"
export * from "./DigitalMainView.vue?vue&type=script&lang=js&"
import style0 from "./DigitalMainView.vue?vue&type=style&index=0&id=b5e39e18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e39e18",
  null
  
)

export default component.exports